export interface TestPrioritizationState {
  testCasesToSourceMapping: any[];
  loading: boolean;
  error: string | null;
  isMappingCreated: boolean;
  mappingResponse: any;
  recommandations: any[]
}

export const initialState: TestPrioritizationState = {
  testCasesToSourceMapping: [],
  loading: false,
  error: null,
  isMappingCreated: false,
  mappingResponse: null,
  recommandations: []
};
